import { GridColumnType } from "../../../../../../../../components/FinalMolGrid/libs/data/gridColumnType";

export const NewRefrenceTaskGridConfig = {
  columns: [
    {
      name: "Action",
      fieldName: "isSelected",
      colType: GridColumnType.CHECKBOX,
      colSettings: {
        allowEdit: true,
      },
      colStyle: {
        textAlign: "center",
        width: "10%",
      },
      allowShort: false,
    },
    {
      name: "TaskId",
      fieldName: "taskId",
      allowShort: false,
      colStyle: {
        width: "15%",
        textAlign: "center",
      },
    },
    {
      name: "Task Name",
      fieldName: "title",
      allowShort: false,
      colStyle: {
        width: "75%",
        textAlign: "center",
      },
    },
  ],
  allowEdit: true,
  handleRowDataUpdate: null,
  OnColumnChangeEdit: null,
  hasChildGridTable: false,
};
